import type { Component, Style, ShapeDividerStyle } from '@wix/thunderbolt-becky-types'
import { createCssCompNode } from '../cssCompNode'
import type { FeatureRefs } from '../cssFeatures.types'
import { getBackgroundProps } from './utils'
import { isRefArray } from '../../utils/variantsUtils'
import { toBreakpointVariantsMap } from '../../utils/toBreakpointVariantsMap'
import { toCompVariants } from '../../utils/toCompVariants'

export const svgBackgroundImage = createCssCompNode('svgBackgroundImage', 'svgBackgroundImage', {
	getDependencies: (component: Component, refs: FeatureRefs<'svgBackgroundImage'>) => {
		return component?.builderType ===
			'platform.builder.88110a9d-ba44-450e-bcf9-17058af00b76_3f4bd8f4-7124-4b69-a189-a03bd8ea7adf' &&
			component.styleId
			? {
				compStyle: refs.styleId(component.styleId),
			}
			: null
	},
	toViewItem: (__, deps) => {
		if (!deps || !deps?.compStyle) {
			return null
		}

		const { compStyle } = deps

		const getStyleObj = (style: ShapeDividerStyle) => {
			const { cssCustomProperties, resolvedSvg, id } = style
			const { side, repeats, invert, keepAspectRatio, height, color } = cssCustomProperties || {}

			if (!resolvedSvg || !id || !side) {
				return null
			}

			const { backgroundImage, backgroundSize } = getBackgroundProps({
				id,
				svg: resolvedSvg,
				side,
				height: height || '150px',
				color: color || '#000',
				invert: invert === 'invert',
				keepAspectRatio: keepAspectRatio !== 'stretch',
				repeats: repeats ? parseInt(repeats, 10) : 1,
			})

			return {
				'[data-divider-layer]': {
					'background-image': backgroundImage ?? '',
					'background-size': backgroundSize ?? '',
					...(side === 'top' ? { top: '0', '--scaleY': '-1' } : { bottom: '0', '--scaleY': '1' }),
				},
			}
		}

		if (isRefArray(compStyle)) {
			// @ts-ignore
			const data = toBreakpointVariantsMap(compStyle.values, getStyleObj)
			return {
				data,
				variants: toCompVariants(compStyle.values),
			}
		} else {
			return {
				data: {
					default: {
						// @ts-ignore
						'': getStyleObj(compStyle),
					},
				},
				variants: null,
			}
		}
	},
})
